// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"61802520","455":"e0d586e9","644":"5458dd17"}[chunkId] + ".chunk.js";
};